import { AppThunk } from '../store'
import {
  postResetPassword,
  patchResetPassword,
} from '../../apis/auth'
import { setErrors } from '../common/errorsSlice'
import {
  ResetPassword,
  ResetRequest,
} from '../../types/auth'

export const createResetRequest = (
  params: ResetRequest,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callback: (result: any) => void,
): AppThunk => async (dispatch) => {
  postResetPassword(params)
    .then((result) => {
      callback(result)
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const updatePasswordWithToken = (
  params: ResetPassword,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callback: (result: any) => void,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errorCallback: (error: any) => void,
): AppThunk => async (dispatch) => {
  patchResetPassword(params)
    .then((result) => {
      callback(result)
    })
    .catch((error) => {
      dispatch(setErrors(error))
      errorCallback(error.errors)
    })
}
